module.exports = __webpack_public_path__ + "static/media/Clone.c211d69b.svg";